import { render, staticRenderFns } from "./resetting.vue?vue&type=template&id=21ffc7ac&scoped=true&"
import script from "./resetting.vue?vue&type=script&lang=js&"
export * from "./resetting.vue?vue&type=script&lang=js&"
import style0 from "./resetting.vue?vue&type=style&index=0&id=21ffc7ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ffc7ac",
  null
  
)

export default component.exports